module.exports = __webpack_public_path__ + "static/media/Adrian.92e3d652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Adrian.png
// module id = 1430
// module chunks = 0